import { AppDispatch } from "..";
import { agentApi } from "./agentApi";
import { auditctxApi } from "./auditctxApi";
import { cloudAccountApi } from "./cloudaccountApi";
import { domainApi } from "./domainApi";
import { groupApi } from "./groupApi";
import { gvcApi } from "./gvcApi";
import { identityApi } from "./identityApi";
import { imageApi } from "./imageApi";
import { ipSetApi } from "./ipSetApi";
import { locationApi } from "./locationApi";
import { mk8sApi } from "./mk8sApi";
import { policyApi } from "./policyApi";
import { quotaApi } from "./quotaApi";
import { secretApi } from "./secretApi";
import { serviceAccountApi } from "./serviceAccountApi";
import { userApi } from "./userApi";
import { volumeSetApi } from "./volumeSetApi";
import { workloadApi } from "./workloadApi";

export function invalidateCacheForKind(dispatch: AppDispatch, kind: string, links: string[]) {
  switch (kind) {
    case "agent":
      dispatch(agentApi.util.invalidateTags(links.map((link) => ({ type: "Agent" as const, id: link }))));
      break;
    case "auditctx":
      dispatch(auditctxApi.util.invalidateTags(links.map((link) => ({ type: "AuditContext" as const, id: link }))));
      break;
    case "cloudaccount":
      dispatch(
        cloudAccountApi.util.invalidateTags(links.map((link) => ({ type: "CloudAccount" as const, id: link }))),
      );
      break;
    case "domain":
      dispatch(domainApi.util.invalidateTags(links.map((link) => ({ type: "Domain" as const, id: link }))));
      break;
    case "group":
      dispatch(groupApi.util.invalidateTags(links.map((link) => ({ type: "Group" as const, id: link }))));
      break;
    case "gvc":
      dispatch(gvcApi.util.invalidateTags(links.map((link) => ({ type: "Gvc" as const, id: link }))));
      break;
    case "identity":
      dispatch(identityApi.util.invalidateTags(links.map((link) => ({ type: "Identity" as const, id: link }))));
      break;
    case "image":
      dispatch(imageApi.util.invalidateTags(links.map((link) => ({ type: "Image" as const, id: link }))));
      break;
    case "ipset":
      dispatch(ipSetApi.util.invalidateTags(links.map((link) => ({ type: "IpSet" as const, id: link }))));
      break;
    case "location":
      dispatch(locationApi.util.invalidateTags(links.map((link) => ({ type: "Location" as const, id: link }))));
      break;
    case "mk8s":
      dispatch(mk8sApi.util.invalidateTags(links.map((link) => ({ type: "Mk8sCluster" as const, id: link }))));
      break;
    case "policy":
      dispatch(policyApi.util.invalidateTags(links.map((link) => ({ type: "Policy" as const, id: link }))));
      break;
    case "quota":
      dispatch(quotaApi.util.invalidateTags(links.map((link) => ({ type: "Quota" as const, id: link }))));
      break;
    case "secret":
      dispatch(secretApi.util.invalidateTags(links.map((link) => ({ type: "Secret" as const, id: link }))));
      break;
    case "serviceaccount":
      dispatch(
        serviceAccountApi.util.invalidateTags(links.map((link) => ({ type: "ServiceAccount" as const, id: link }))),
      );
      break;
    case "user":
      dispatch(userApi.util.invalidateTags(links.map((link) => ({ type: "User" as const, id: link }))));
      break;
    case "volumeset":
      dispatch(volumeSetApi.util.invalidateTags(links.map((link) => ({ type: "VolumeSet" as const, id: link }))));
      break;
    case "workload":
      dispatch(workloadApi.util.invalidateTags(links.map((link) => ({ type: "Workload" as const, id: link }))));
      break;
  }
}
